/** Tailwind CSS v4 chromatic families for custom tag colors (no neutral grays). */
export const TAILWIND_TAG_COLOR_FAMILIES = [
  "red",
  "orange",
  "amber",
  "yellow",
  "lime",
  "green",
  "emerald",
  "teal",
  "cyan",
  "sky",
  "blue",
  "indigo",
  "violet",
  "purple",
  "fuchsia",
  "pink",
  "rose",
] as const;

export const TAILWIND_TAG_COLOR_SHADES = ["200", "300", "400"] as const;

export type TailwindTagColorFamily =
  (typeof TAILWIND_TAG_COLOR_FAMILIES)[number];
export type TailwindTagColorShade = (typeof TAILWIND_TAG_COLOR_SHADES)[number];
export type TailwindTagBgClass =
  `bg-${TailwindTagColorFamily}-${TailwindTagColorShade}`;

export const DEFAULT_TAG_BG_COLOR: TailwindTagBgClass = "bg-emerald-200";

export const TAILWIND_TAG_BG_CLASSES: TailwindTagBgClass[] =
  TAILWIND_TAG_COLOR_FAMILIES.flatMap((family) =>
    TAILWIND_TAG_COLOR_SHADES.map(
      (shade) => `bg-${family}-${shade}` as TailwindTagBgClass
    )
  );

/** Space-separated class list for Tailwind `@source inline(...)` safelist. */
export const TAILWIND_TAG_BG_CLASSES_SAFELIST =
  TAILWIND_TAG_BG_CLASSES.join(" ");
